import {
    BranchWithUserData,
    BranchWithUsersDto,
    LeaveRequestUserInfoIncluded,
    DisabledDays,
    ProjectOverviewDto,
    TimeLogUserSummaryWithUserInfoDto,
    TimeLogsByProjectWithLeaveRequestsDto,
    ProjectWithAssigneesDto,
    TeamsWithUsersDto,
    TeamMembersWithBranchNameDto,
    TeamMembersWithSubTeamsPayload,
    TeamWithTeamLeadDto,
    OrganizationMembersWithBranchDataDto,
    ProjectAssigneesRatesDto,
    MedicalLeaveRequestUserInfoIncluded,
    TotalEarningsByClientDto,
} from '../commonTypes/acs';
import { AbsentColleaguesDto, UserOrganizationPolicyDto, UserProfileExtendedDto } from '../commonTypes/acs/user.types';
import { ClientSummaryOverviewDto } from '../commonTypes/client.types';
import { LeaveRequestStatus } from '../commonTypes/leaveRequest.types';
import { HolidayDto } from '../commonTypes/organization.types';
import { Page, Pageable, PageableWithDateRange } from '../commonTypes/pageable.types';
import { ProjectAssigneesWithUserInfoDto, ProjectDtoRelV2, ActivityFeedWithUserDto } from '../commonTypes/project.types';
import { UserProfileWithRoleDto } from '../commonTypes/user.types';
import { diContainer } from '../libs/container';
import { ApiBaseClass, IServiceHttp } from './ApiBase';

export namespace ACSApiRequest {
    export interface TimeLogSummary {
        params: {
            projectId: string;
        };
        query: PageableWithDateRange;
    }

    export interface DateQuery {
        query: {
            from: string;
            to: string;
            userSub?: string;
        };
    }

    export interface GetLeaveRequestsByInterval {
        query: {
            search?: string;
        };
        body: {
            from: string;
            to: string;
            status?: LeaveRequestStatus[];
        };
    }

    export interface GetLeaveRequestsFromOrganization {
        query: {
            organizationId: string;
            status?: LeaveRequestStatus;
            page?: number;
            size?: number;
            sort?: string;
            direction?: 'asc' | 'desc';
        };
    }

    export interface GetProjectAssigneesOfProject {
        params: {
            projectId: string;
        };
        query: Pageable;
    }

    export interface GetPossibleAssignees {
        params: {
            projectId: string;
        };
        body: {
            roleNames: string[];
        };
    }

    export interface GetAbsentColleagues {}

    export interface GetProjectOverview {
        params: {
            projectId: string;
        };
        query: {
            from: string;
            to: string;
            page: number;
            size: number;
        };
    }

    export interface GetUserPolicies {}

    export interface GetUserProfileData {
        params: {
            userSub: string;
        };
    }

    export interface GetBranchesWithUsersData {}
    export interface GetBranchWithUsers {
        params: {
            branchId: string;
        };
    }

    export interface GetProjectWithClientUserBranch {
        params: {
            id: string;
        };
        query: {
            assigneeStatus?: string;
        };
    }
    export interface GetTeamsWithUsersData {}
    export interface GetUsersTeamsWithUsersData {
        params: {
            userSub: string;
        };
    }
    export interface GetProfileUsersTeamsData {
        params: {
            userSub: string;
        };
    }

    export interface GetTeamMembers {
        params: {
            teamId: string;
        };
        query?: {
            includeSubTeams?: 'true' | 'false';
        };
    }
    export interface GetTeamWithTeamLead {
        params: {
            id: string;
        };
    }

    export interface GetOrganizationMembersWithBranchData {
        params: {
            organizationId: string;
        };
        query: {
            page: number;
            size: number;
            branchId?: string;
            organizationPolicyId?: string;
            search?: string;
        };
    }

    export interface GetHolidaysByUserSub {
        params: {
            userSub: string;
        };
    }

    export interface GetAllLeaveRequestsByOrganizationId {
        params: {
            organizationId: string;
        };
    }
    export interface GetInvoiceAmounts {
        params: {
            from: string;
            to: string;
        };
        body: {
            projectIds: string[];
        };
    }
    export interface GetMedicalLeaveRequestsFromOrganization {
        query: {
            status?: LeaveRequestStatus;
            page?: number;
            size?: number;
            sort?: string;
            direction?: 'asc' | 'desc';
        };
    }

    export interface GetAllProjectsWithAssignees {
        query?: {
            archived?: boolean;
        };
    }

    export interface ArchiveProject {
        params: {
            id: string;
        };
    }

    export interface UnarchiveProject {
        params: {
            id: string;
        };
    }

    export interface GetProjectSummaryOverview {
        params: {
            projectId: string;
        };
        query: {
            month: string;
            year: number;
        };
    }

    export interface GetActivityFeedWithUser {
        params: {
            projectId: string;
        };
    }

    export interface GetCombinedActivityLogs {
        params: {
            projectId: string;
        };
    }

    export interface GetClientSummaryOverview {
        params: {
            clientId: string;
        };
        query: {
            month: string;
            year: number;
        };
    }
    export interface GetClientTotalEarnings {
        params: {
            clientId: string;
        };
    }

    export interface GetActivityFeedWithUserData {
        params: {
            projectId: string;
        };
    }
}

export namespace ACSApiResponse {
    export interface TimeLogSummary {
        body: Page<TimeLogUserSummaryWithUserInfoDto>;
    }

    export interface GetTimeLogsByInterval {
        body: TimeLogsByProjectWithLeaveRequestsDto;
    }

    export interface GetLeaveRequestsByInterval {
        body: LeaveRequestUserInfoIncluded[];
    }

    export interface GetProjectAssigneesOfProject {
        body: Page<ProjectAssigneesWithUserInfoDto>;
    }

    export interface GetDisabledDays {
        body: DisabledDays;
    }

    export interface GetLeaveRequestsFromOrganization {
        body: Page<LeaveRequestUserInfoIncluded>;
    }

    export interface GetPossibleAssignees {
        body: UserProfileWithRoleDto[];
    }

    export interface GetAbsentColleagues {
        body: AbsentColleaguesDto[];
    }

    export interface GetProjectOverview {
        body: ProjectOverviewDto[];
    }

    export interface GetUserPolicies {
        body: UserOrganizationPolicyDto[];
    }

    export interface GetUserProfileData {
        body: UserProfileExtendedDto;
    }

    export interface GetBranchesWithUsersData {
        body: BranchWithUserData[];
    }
    export interface GetBranchWithUsers {
        body: BranchWithUsersDto;
    }

    export interface GetProjectWithClientUserBranch {
        body: ProjectWithAssigneesDto;
    }
    export interface GetTeamsWithUsers {
        body: TeamsWithUsersDto[];
    }

    export interface GetProfileUsersTeams {
        body: TeamWithTeamLeadDto[];
    }

    export interface GetTeamMembers {
        body: TeamMembersWithBranchNameDto[] | TeamMembersWithSubTeamsPayload;
    }

    export interface GetTeamWithTeamLead {
        body: TeamWithTeamLeadDto;
    }

    export interface GetOrganizationMembersWithBranchData {
        body: Page<OrganizationMembersWithBranchDataDto>;
    }

    export interface GetHolidaysByUserSub {
        body: HolidayDto[];
    }

    export interface GetAllLeaveRequestsAndUsersByOrganizationId {
        body: LeaveRequestUserInfoIncluded[];
    }

    export interface GetInvoiceAmounts {
        body: ProjectAssigneesRatesDto[];
    }

    export interface GetMedicalLeaveRequestsFromOrganization {
        body: Page<MedicalLeaveRequestUserInfoIncluded>;
    }

    export interface GetAllProjectsWithAssignees {
        body: ProjectDtoRelV2[];
    }

    export interface ArchiveProject {
        body: ProjectDtoRelV2;
    }

    export interface UnarchiveProject {
        body: ProjectDtoRelV2;
    }

    export interface GetProjectSummaryOverview {
        body: ProjectOverviewDto[];
    }

    export interface GetActivityFeedWithUser {
        body: ActivityFeedWithUserDto;
    }

    export interface GetCombinedActivityLogs {
        body: Array<IActivityLog | SubmissionIntervalActivityLogDto>;
    }

    export interface GetClientSummaryOverview {
        body: ClientSummaryOverviewDto[];
    }
    export interface GetClientTotalEarnings {
        body: TotalEarningsByClientDto;
    }
    export interface GetActivityFeedWithUserData {
        body: ActivityFeedWithUserDto;
    }
}

export interface IActivityLog {
    id: string;
    initiatorUserSub: string;
    initiatorName: {
        givenName: string;
        familyName: string;
    };
    affectedUsers: string[];
    activityLogType: string;
    activityLogDetails: any;
    createdAt: Date | undefined;
    status: string;
}

export type SubmissionIntervalActivityLogDetailsDto = {
    projectId: string;
    month: string;
    submissionIntervalId: string;
};

export type SubmissionIntervalActivityLogDto = {
    id: string;
    initiatorUserSub: string;
    initiatorName: {
        givenName: string;
        familyName: string;
    };
    affectedUsers: string[];
    activityLogType: string;
    activityLogDetails: SubmissionIntervalActivityLogDetailsDto;
    createdAt: Date | undefined;
    status: string;
};

export class ACSApi {
    constructor(private readonly apiBase: ApiBaseClass) {}

    public getTimeLogSummary(rest: IServiceHttp<ACSApiRequest.TimeLogSummary, ACSApiResponse.TimeLogSummary>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/time-log/interval/summary/:projectId',
        });
    }

    public getTimeLogsByInterval(rest: IServiceHttp<ACSApiRequest.DateQuery, ACSApiResponse.GetTimeLogsByInterval>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/time-log.withSubmissionIntervals',
        });
    }

    public getLeaveRequestsByInterval(rest: IServiceHttp<ACSApiRequest.GetLeaveRequestsByInterval, ACSApiResponse.GetLeaveRequestsByInterval>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'acs/v1/leave-request/organization/-byInterval',
        });
    }

    public getProjectAssigneesOfProject(rest: IServiceHttp<ACSApiRequest.GetProjectAssigneesOfProject, ACSApiResponse.GetProjectAssigneesOfProject>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/project-assignee/:projectId',
        });
    }

    public getDisabledDays(rest: IServiceHttp<ACSApiRequest.DateQuery, ACSApiResponse.GetDisabledDays>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/leave-request/disabled-days',
        });
    }

    public getLeaveRequestsFromOrganization(
        rest: IServiceHttp<ACSApiRequest.GetLeaveRequestsFromOrganization, ACSApiResponse.GetLeaveRequestsFromOrganization>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/leave-request/organization',
        });
    }

    public getPossibleAssignees(rest: IServiceHttp<ACSApiRequest.GetPossibleAssignees, ACSApiResponse.GetPossibleAssignees>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'acs/v1/project-assignee/subs/:projectId',
        });
    }

    public getAbsentColleagues(rest: IServiceHttp<ACSApiRequest.GetAbsentColleagues, ACSApiResponse.GetAbsentColleagues>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/user.absent-colleagues',
        });
    }

    public getProjectOverview(rest: IServiceHttp<ACSApiRequest.GetProjectOverview, ACSApiResponse.GetProjectOverview>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/project/overview/projectId/:projectId',
        });
    }

    public getUserPolicies(rest: IServiceHttp<ACSApiRequest.GetUserPolicies, ACSApiResponse.GetUserPolicies>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/user/policies',
        });
    }

    public getUserProfileData(rest: IServiceHttp<ACSApiRequest.GetUserProfileData, ACSApiResponse.GetUserProfileData>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/user/policies/:userSub',
        });
    }

    public getOrganizationBranchesWithUsers(rest: IServiceHttp<ACSApiRequest.GetBranchesWithUsersData, ACSApiResponse.GetBranchesWithUsersData>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/organization/branches-with-users',
        });
    }

    public getBranchWithUsers(rest: IServiceHttp<ACSApiRequest.GetBranchWithUsers, ACSApiResponse.GetBranchWithUsers>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/organization/branch/branchId/:branchId',
        });
    }

    public getProjectWithClientUserBranch(
        rest: IServiceHttp<ACSApiRequest.GetProjectWithClientUserBranch, ACSApiResponse.GetProjectWithClientUserBranch>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/project/id/:id',
        });
    }

    public getTeamsWithUsers(rest: IServiceHttp<ACSApiRequest.GetTeamsWithUsersData, ACSApiResponse.GetTeamsWithUsers>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/organization/teams-with-users',
        });
    }
    public getUsersTeamsWithUsers(rest: IServiceHttp<ACSApiRequest.GetUsersTeamsWithUsersData, ACSApiResponse.GetTeamsWithUsers>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/organization/teams-with-users/userSub/:userSub',
        });
    }
    public getProfileUsersTeams(rest: IServiceHttp<ACSApiRequest.GetProfileUsersTeamsData, ACSApiResponse.GetProfileUsersTeams>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/organization/team/-byUser/userSub/:userSub',
        });
    }
    public getUsersTeams(rest: IServiceHttp<ACSApiRequest.GetTeamsWithUsersData, ACSApiResponse.GetTeamsWithUsers>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/organization/team/-byUser',
        });
    }

    public getTeamMembers(rest: IServiceHttp<ACSApiRequest.GetTeamMembers, ACSApiResponse.GetTeamMembers>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/organization/team/teamId/:teamId/users-with-branches',
        });
    }

    public getOneTeamWithTeamLead(rest: IServiceHttp<ACSApiRequest.GetTeamWithTeamLead, ACSApiResponse.GetTeamWithTeamLead>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/organization/team/id/:id',
        });
    }

    public getOrganizationMembersWithBranchData(
        rest: IServiceHttp<ACSApiRequest.GetOrganizationMembersWithBranchData, ACSApiResponse.GetOrganizationMembersWithBranchData>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/organization/:organizationId/users-paginated',
        });
    }

    public getHolidaysByUserSub(rest: IServiceHttp<ACSApiRequest.GetHolidaysByUserSub, ACSApiResponse.GetHolidaysByUserSub>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/user/userSub/:userSub/holidays',
        });
    }

    public getAllLeaveRequestsAndUsersByOrganizationId(
        rest: IServiceHttp<ACSApiRequest.GetAllLeaveRequestsByOrganizationId, ACSApiResponse.GetAllLeaveRequestsAndUsersByOrganizationId>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/leave-request/organizationId/:organizationId',
        });
    }

    public getInvoiceAmounts(rest: IServiceHttp<ACSApiRequest.GetInvoiceAmounts, ACSApiResponse.GetInvoiceAmounts>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'acs/v1/time-log/from/:from/to/:to/-getInvoiceAmounts',
        });
    }

    public getMedicalLeaveRequestsFromOrganization(
        rest: IServiceHttp<ACSApiRequest.GetMedicalLeaveRequestsFromOrganization, ACSApiResponse.GetMedicalLeaveRequestsFromOrganization>
    ) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/medical-leave-request/organization',
        });
    }

    public getAllProjectsWithAssignees(rest: IServiceHttp<ACSApiRequest.GetAllProjectsWithAssignees, ACSApiResponse.GetAllProjectsWithAssignees>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/projects',
        });
    }

    public archiveProject(rest: IServiceHttp<ACSApiRequest.ArchiveProject, ACSApiResponse.ArchiveProject>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'acs/v1/project/id/:id/archive',
        });
    }

    public unarchiveProject(rest: IServiceHttp<ACSApiRequest.UnarchiveProject, ACSApiResponse.UnarchiveProject>) {
        return this.apiBase.configure({
            ...rest,
            method: 'POST',
            url: 'acs/v1/project/id/:id/unarchive',
        });
    }

    public getProjectSummaryOverview(rest: IServiceHttp<ACSApiRequest.GetProjectSummaryOverview, ACSApiResponse.GetProjectSummaryOverview>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/project/summary-overview/:projectId',
        });
    }

    public getActivityFeedWithUser(rest: IServiceHttp<ACSApiRequest.GetActivityFeedWithUser, ACSApiResponse.GetActivityFeedWithUser>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/activity-feed/:projectId',
        });
    }

    public getCombinedActivityLogs(rest: IServiceHttp<ACSApiRequest.GetCombinedActivityLogs, ACSApiResponse.GetCombinedActivityLogs>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/project/:projectId/activity-logs',
        });
    }

    public getClientSummaryOverview(rest: IServiceHttp<ACSApiRequest.GetClientSummaryOverview, ACSApiResponse.GetClientSummaryOverview>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/client/:clientId/summary-overview',
        });
    }
    public getClientTotalEarnings(rest: IServiceHttp<ACSApiRequest.GetClientTotalEarnings, ACSApiResponse.GetClientTotalEarnings>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/project/:clientId/total-earnings-by-client',
        });
    }

    public getActivityFeedWithUserData(rest: IServiceHttp<ACSApiRequest.GetActivityFeedWithUserData, ACSApiResponse.GetActivityFeedWithUserData>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'acs/v1/project/:projectId/activity-feed',
        });
    }
}

diContainer.bindAsDynamic(ACSApi, c => new ACSApi(c.get(ApiBaseClass)));
